import { WebLayout } from 'components/Layout';
import React, { useEffect, useState } from 'react';
import ProductHuntRafiki from 'assets/product-hunt-rafiki.svg';

export const OurProducts = () => {
  const [showComingSoon, setShowComingSoon] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleTribeTeeClick = (e) => {
    e.preventDefault();
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 5000);
  };

  const products = [
    {
      name: 'LonaPay',
      tagline: 'Bankless. Borderless. Reputation-based.',
      link: 'https://lonapay.org',
      description:
        'A protocol for people who want to save, borrow, and grow their reputation — without banks, penalties, or rigid rules.',
      theme: 'from-purple-700 via-pink-500 to-red-500',
      action: 'link',
    },
    {
      name: 'tribeTee™',
      tagline: 'Culture, Printed.',
      description:
        'A niche POD e-commerce platform targeting the African diaspora and the culturally curious.',
      theme: 'from-yellow-400 via-red-500 to-pink-500',
      action: 'popup',
    },
  ];

  return (
    <WebLayout>
      <div className="p-8 px-8 md:px-56">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center mb-16">
          <div className="text-center md:text-start">
            <div className="text-4xl league-spartan-extra-bold md:text-7xl text-black dark:text-white">
              Our <span className="text-[#F9A200]">Products.</span>
            </div>
            <div className="text-3xl league-spartan-bold mb-3 dark:text-white">
              We build & maintain our products.
            </div>
            <div className="text-xl dark:text-white">
              Feel free to try out any of our products and leave a review. Your input helps us make
              our products better for your use.
            </div>
          </div>
          <div className="flex flex-row justify-center md:justify-end">
            <img src={ProductHuntRafiki} alt="Product Illustration" className="h-64 md:h-[24vw]" />
          </div>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {products.map((product, idx) =>
            product.action === 'link' ? (
              <a
                key={idx}
                href={product.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`rounded-xl p-8 bg-gradient-to-br ${product.theme} text-white shadow-lg transform hover:scale-105 transition-all duration-300 cursor-pointer`}
              >
                <h3 className="text-3xl font-bold mb-2">{product.name}</h3>
                <h4 className="text-lg font-semibold mb-2">{product.tagline}</h4>
                <p className="text-white/80">{product.description}</p>
              </a>
            ) : (
              <div
                key={idx}
                onClick={handleTribeTeeClick}
                className={`rounded-xl p-8 bg-gradient-to-br ${product.theme} text-white shadow-lg transform hover:scale-105 transition-all duration-300 cursor-pointer`}
              >
                <h3 className="text-3xl font-bold mb-2">{product.name}</h3>
                <h4 className="text-lg font-semibold mb-2">{product.tagline}</h4>
                <p className="text-white/80">{product.description}</p>
              </div>
            )
          )}
        </div>
      </div>

      {/* Coming Soon Modal */}
      {showComingSoon && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white dark:bg-gray-900 text-black dark:text-white p-8 rounded-xl shadow-xl max-w-md w-full mx-4 text-center relative animate-fade-in">
            <h2 className="text-3xl font-bold mb-4 text-[#F9A200]">tribeTee™ is Coming Soon!</h2>
            <p className="text-lg mb-6">
              We’re working hard to bring this cultural platform to life. Stay tuned!
            </p>

            <div className="w-full h-2 bg-gray-300 dark:bg-gray-800 rounded-full overflow-hidden">
              <div className="h-full bg-[#F9A200] animate-progress-bar"></div>
            </div>
          </div>
        </div>
      )}

      {/* Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }

          .animate-fade-in {
            animation: fadeIn 0.4s ease-out forwards;
          }

          @keyframes progressBar {
            from { width: 0%; }
            to { width: 100%; }
          }

          .animate-progress-bar {
            animation: progressBar 4.5s linear forwards;
          }
        `}
      </style>
    </WebLayout>
  );
};
